import Store from 'Store/.';
import { Dispatch } from 'redux';
import Api from 'Helpers/Api';

import { 
  EventAction, 
  setEvent,
  setIsFetching, 
  setFetchFailed, 
} from 'Pages/EventDetailPage/Redux/actions';
import moment from 'moment';

export const fetchEvent = (id: number, code: string) => {
  return async (dispatch: Dispatch<EventAction>): Promise<void> => {
    const { isFetching } = Store.getState().event;

    if (!id || isFetching) {
      return null;
    }

    dispatch(setIsFetching());

    try {
      const queryParams = code ? `eventID=${ id }&campaignCode=${ code }` : `eventID=${ id }`;
      const response = await Api.get('EventDetail', queryParams);
      const newEvent: Julius.Website.EventDetailViewModel = await response.json();

      newEvent.performances.map(p => {
        p.date = moment(p.date).toDate();
        p.startSaleDate = moment(p.startSaleDate).toDate();
        p.stopSaleDate = moment(p.stopSaleDate).toDate();
      });

      dispatch(setEvent(newEvent));
    } catch (e) {
      dispatch(setFetchFailed());
    }
  };
};


// WEBPACK FOOTER //
// ./src/pages/EventDetailPage/Redux/thunks.tsx